const shopWideTextWithForm = {
  displayField: 'header',
  name: 'z-Shop Wide Text with Form',
  description: 'do not use',
  fields: [
    {
      id: 'backgroundColor',
      name: 'Background Color',
      type: 'Boolean',
      localized: false,
      required: false,
      validations: [],
      defaultValue: { 'en-US': true },
      disabled: false,
      omitted: false
    },
    {
      id: 'reverse',
      name: 'Form Position',
      type: 'Boolean',
      localized: false,
      required: false,
      validations: [],
      defaultValue: { 'en-US': true },
      disabled: false,
      omitted: false
    },
    {
      id: 'imgFocalPoint',
      name: 'ImageFocalPoint',
      type: 'Link',
      localized: false,
      required: false,
      validations: [ { linkContentType: [ 'imageWithFocalPoint' ] } ],
      disabled: false,
      omitted: false,
      linkType: 'Entry'
    },
    {
      id: 'img',
      name: 'img',
      type: 'Link',
      localized: false,
      required: false,
      validations: [],
      disabled: true,
      omitted: true,
      linkType: 'Asset'
    },
    {
      id: 'eyebrow',
      name: 'Eyebrow',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'header',
      name: 'Header',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'bodyText',
      name: 'Body Text',
      type: 'Text',
      localized: false,
      required: false,
      validations: [],
      disabled: true,
      omitted: true
    },
    {
      id: 'richText',
      name: 'RichText',
      type: 'RichText',
      localized: false,
      required: false,
      validations: [
        {
          enabledMarks: [ 'bold', 'italic' ],
          message: 'Only bold and italic marks are allowed'
        },
        { enabledNodeTypes: [], message: 'Nodes are not allowed' },
        { nodes: {} }
      ],
      disabled: false,
      omitted: false
    },
    {
      id: 'links',
      name: 'Links',
      type: 'Array',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false,
      items: {
        type: 'Link',
        validations: [ { linkContentType: [ 'linkDownload', 'link' ] } ],
        linkType: 'Entry'
      }
    },
    {
      id: 'bodyText2',
      name: 'bodyText2',
      type: 'Text',
      localized: false,
      required: false,
      validations: [],
      disabled: true,
      omitted: true
    },
    {
      id: 'ctaText',
      name: 'ctaText',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: true,
      omitted: true
    },
    {
      id: 'ctaUrl',
      name: 'ctaUrl',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: true,
      omitted: true
    },
    {
      id: 'swatch',
      name: 'swatch',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: true,
      omitted: true
    },
    {
      id: 'formHeader',
      name: 'Form Header',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'formDescription',
      name: 'Form Description',
      type: 'RichText',
      localized: false,
      required: false,
      validations: [
        {
          enabledMarks: [ 'bold', 'italic' ],
          message: 'Only bold and italic marks are allowed'
        },
        {
          enabledNodeTypes: [ 'hyperlink', 'entry-hyperlink' ],
          message: 'Only link to Url and link to entry nodes are allowed'
        },
        { nodes: {} }
      ],
      disabled: false,
      omitted: false
    },
    {
      id: 'buttonText',
      name: 'Form Button Text',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    }
  ],
  sys: {
    id: 'shopWideTextWithForm',
    version: 4,
    updatedAt: '2023-08-02T22:14:23.378Z'
  }
};
export default shopWideTextWithForm;